import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiFormHelperText = {
  styleOverrides: { root: {position:"absolute", top:"100%", left:"5px", marginTop:"-2px"} },
} satisfies Components<Theme>['MuiFormHelperText'];
